const MUTUAL_TRANSLATIONS = {
  // time period
  PERIOD_SELECT_THIS_WEEK: 'این هفته',
  PERIOD_SELECT_LAST_7: 'هفت روز گذشته',
  PERIOD_SELECT_THIS_MONTH: 'این ماه',
  PERIOD_SELECT_LAST_3_MONTH: 'سه ماه گذشته',
  PERIOD_SELECT_LAST_YEAR: 'یک سال گذشته',
  PERIOD_SELECT_CHOOSE_CALENDAR: 'انتخاب بازه از تقویم',

  // conversation statuses
  CLOSED_CONVERSATION: 'مکالمات پایان یافته',
  ACCEPTED_CONVERSATION: 'مکالمات قبول شده',
  OPENED_CONVERSATION: 'مکالمات در انتظار پاسخ',
  CLOSED_AGENT_CONVERSATION: 'مکالمات بدون پاسخ',
  DENIED_CONVERSATION: 'مکالمات رد شده',

  STATISTICS_DATE_PICKER_PLACEHOLDER: 'فیلتر بر حسب تاریخ',
};

export default MUTUAL_TRANSLATIONS;
